import React from 'react'
import NumberFormat from 'react-number-format'
import { Spin } from 'antd'

export default function ContractStatisticWidget(props) {

  const { title, value, prefix, suffix, decimals, thousandSeparator, isLoading } = props
  return (
    <div className='contract-statistic-container'>
      <div className='contract-stats-title'>
        {title}
      </div>

      {
        isLoading ? (
          <div className='loading-container'>
            <Spin style={{ color: 'red' }} size="large" />
          </div>) : (
          <div className='contract-stats-value-container'>
            <div className='value-prefix'>
              {prefix}
            </div>
            <div className='contract-stats-value'>
              <NumberFormat
                className='contract-stats-value-field'
                style={{ marginRight: '5px' }}
                value={value ? value : 0.00}
                displayType="text"
                decimalScale={decimals ? decimals : 2}
                thousandSeparator={thousandSeparator ? thousandSeparator : false}
              />
              <div className='value-suffix'>
                {suffix}
              </div>
            </div>
          </div>
        )
      }

    </div>
  )
}
